import { getRandomId } from './utils'
export const CATALOG_MAIN_LINK = 'catalog'
export const CATALOG_ITEM_LINK = 'item'
export const CART_MAIN_LINK = 'cart'
export const SUCCESSFUL_PAYMENT_LINK = 'successful-payment'
export const USER_AGREEMENT_LINK = 'user-agreement'
export const PRIVACY_POLICY_LINK = 'privacy-policy'
export const CONTACT_US_LINK = 'contact-us'
export const STATIC_DOCS_LINK = 'docs'
export const SEARCH_PAGE = 'search'
export const FAVORITE_LINK = 'favorite'
export const FAQ_LINK = 'faq'
export const MOBILE_APP_MAIN_LINK = 'app'
export const MOBILE_APP_RESET_PASSWORD_LINK = 'reset-password'


export const MAIN_URL = "https://app.sanywatches.com/public";
export const APP_API_URL = "https://app.sanywatches.com/sany-app";
export const MAIN_URL_SANY = 'https://app.sanywatches.com/sany'
export const INST_URL = 'https://inst-parser.sanywatches.com'
export const LEAD_URL = 'https://tg-function.yc-cabatest.ru/SANY_NOTIFIER'
// export const MAIN_URL = "https://sellone-backend.cabatest.ru/public";

export const DEV_SHOP_ID = "67639189fd2e8b810942df8b"

export const PHONE = '+7 925 114-50-54'
export const EMAIL = 'neplaneta@gmail.com'
export const ARTICL_NAME = "Артикул"
export const RECENTLY_VIEW_LS_KEY = 'recently-view'
export const OPEN_ITEM_REQUEST = 'item-open-request'
export const POSSIBLE_CONDITION = [
    ' Brand New, 2024 Model',
    'Perfect Condition',
    'Like New',
    'New with Original Packaging',
    'Pre - owned, Excellent Condition',
    'Very Good Condition',
    'Good Condition',
    'Lightly Used',
    'With Minor Signs of Use',
    'Requires Repair',
    'Restored',
    `Limited Edition`,
    `Collector's Condition`,
    `Used, Verified`,
    `Previous Owner's Condition`,
    `Packaged for Sale`,
    `Certified Condition`,
    `Exclusive Condition`,
    `Tested and Guaranteed`,
    `Vintage Condition`,
    `Rare Item`,
    `With Usage, Fully Functional`,
    `With Upgraded Components`,
    `No Signs of Use`,
    `Display Model`,
    `With Original Documents`,
    `With Additional Accessories`,
    `Serviced`,
    `With Authenticity Guarantee`,
    `Authenticity Verified`,
]

export const CURRENCY_MAP = {
    'USD': '$',  // United States Dollar
    'EUR': '€',  // Euro
    'JPY': '¥',  // Japanese Yen
    'GBP': '£',  // British Pound
    'AUD': 'A$', // Australian Dollar
    'CAD': 'C$', // Canadian Dollar
    'CHF': 'CHF', // Swiss Franc
    'CNY': '¥',  // Chinese Yuan
    'SEK': 'kr',  // Swedish Krona
    'NZD': 'NZ$', // New Zealand Dollar
    'MXN': '$',  // Mexican Peso
    'SGD': 'S$', // Singapore Dollar
    'HKD': 'HK$', // Hong Kong Dollar
    'NOK': 'kr',  // Norwegian Krone
    'KRW': '₩',  // South Korean Won
    'TRY': '₺',  // Turkish Lira
    'INR': '₹',  // Indian Rupee
    'RUB': '₽',  // Russian Ruble
    'BRL': 'R$', // Brazilian Real
    'ZAR': 'R',  // South African Rand
};

export const CURRENCY = [
    'USD',  // United States Dollar
    'USDT',
    'AED',
    'RUB',  // Russian Ruble
    'EUR',  // Euro
    'JPY',  // Japanese Yen
    'GBP',  // British Pound
    'AUD', // Australian Dollar
    'CAD', // Canadian Dollar
    'CHF', // Swiss Franc
    'CNY',  // Chinese Yuan
    'SEK',  // Swedish Krona
    'NZD', // New Zealand Dollar
    'MXN',  // Mexican Peso
    'SGD', // Singapore Dollar
    'HKD', // Hong Kong Dollar
    'NOK',  // Norwegian Krone
    'KRW',  // South Korean Won
    'TRY',  // Turkish Lira
    'INR',  // Indian Rupee
    'BRL', // Brazilian Real
    'ZAR',  // South African Rand
];

export const IMG_PLACEHOLDER_PRODUCT = 'https://app.sanywatches.com/get-file/public/additional_data/product-placeholder.png'
export const IMG_PLACEHOLDER_PROMO = 'https://app.sanywatches.com/get-file/public/additional_data/promo-placeholder.png'
export const LANDING_URL = 'https://sanywatches.com'

export const DEMO_PRODUCT = {
    "_id": "65ac892aca48bfd1dbd637a2",
    "name": "Demo Product",
    "description": "Demo Descript",
    "options": [
        {
            "name": "3",
            "values": [
                {
                    "value": "3",
                    "price_raise": null,
                    "in_stock": null
                },
                {
                    "value": "4",
                    "price_raise": null,
                    "in_stock": null
                }
            ]
        },
        {
            "name": "4",
            "values": [
                {
                    "value": "3",
                    "price_raise": null,
                    "in_stock": null
                }
            ]
        }
    ],
    "price_data": {
        "price": "123323",
        "discount": 2,
        "in_stock": 10
    },
    "categories": [
        {
            "_id": "65ad0632ca48bfd1dbd637d2",
            "name": "new",
            "translit_name": "new-z9qX",
            "count": 1,
            "is_final": true,
            "parents": [
                {
                    "_id": "65ad0632ca48bfd1dbd637d2",
                    "name": "new",
                    "translit_name": "new-z9qX",
                    "count": 1,
                    "is_final": true
                },
                {
                    "_id": "65acfbe4ca48bfd1dbd637ab",
                    "name": "1",
                    "translit_name": "1-cI5U",
                    "count": 8,
                    "is_final": false
                },
                {
                    "_id": "65ac86cbca48bfd1dbd63794",
                    "name": "Диван кровать",
                    "translit_name": "test-4RPc",
                    "count": 4,
                    "is_final": false
                }
            ]
        },
        {
            "_id": "65acfbecca48bfd1dbd637ad",
            "name": "test",
            "translit_name": "test-kS5l",
            "count": 2,
            "is_final": true,
            "parents": [
                {
                    "_id": "65acfbecca48bfd1dbd637ad",
                    "name": "test",
                    "translit_name": "test-kS5l",
                    "count": 2,
                    "is_final": true
                },
                {
                    "_id": "65ac86cbca48bfd1dbd63794",
                    "name": "Диван кровать",
                    "translit_name": "test-4RPc",
                    "count": 4,
                    "is_final": false
                }
            ]
        }
    ],
    "files": [
        {
            "_id": "65acf9d0ca48bfd1dbd637a5",
            "expire_at": null,
            "urls": {
                "orig": IMG_PLACEHOLDER_PRODUCT,
                // "orig": 'https://placehold.co/100x100',

            }
        }
    ]
}




export const ACTIVITY_PING_TIMEOUT = 5000

export const OWN_DELIVERY_TYPE = 'own_delivery'
export const NO_DELIVERY_TYPE = 'no_delivery'
export const DELIVERY_TYPE_VALUES =
{
    [OWN_DELIVERY_TYPE]: 'Delivery',
    [NO_DELIVERY_TYPE]: 'Pickup',
}

export const WATCHES_CATEGORY_LINK = 'watches'
export const JEWELRY_CATEGORY_LINK = 'jewelry'
export const HERMES_BAGS_CATEGORY_LINK = 'hermes-bags'
export const FINE_ART_CATEGORY_LINK = 'fine-art'
export const ABOUT_US_PAGE_LINK = 'about-us'
export const SELL_TO_US_PAGE_LINK = 'sell-to-us'
export const NEW_CATEGORY_LINK = 'new-arrivals'
export const SPECIAL_CATEGORY_LINK = 'special-offers'

export const ROLEX_CATEGORY_LINK = 'rolex'
export const AUDEMARS_CATEGORY_LINK = 'audemars-piguet'
export const BVLGARY_CATEGORY_LINK = 'bvlgari'
export const CARTIER_CATEGORY_LINK = 'cartier'
export const FRANK_MULLER_CATEGORY_LINK = 'franck-muller'
export const HUBLOT_CATEGORY_LINK = 'hublot'
export const PATEK_PHILIPPE_CATEGORY_LINK = 'patek-philippe'
export const RICHARD_MILE_CATEGORY_LINK = 'richard-mille'
export const FP_JOURNE_CATEGORY_LINK = 'fp-journe'
export const BIRKIN_CATEGORY_LINK = 'birkin'
export const CONSTANCE_CATEGORY_LINK = 'constance'
export const KELLY_CATEGORY_LINK = 'kelly'
export const HERBAG_ZIP_CATEGORY_LINK = 'herbag-zip'
export const EVELYNE_TPM_CATEGORY_LINK = 'evelyne-tpm'
export const HAC_A_DOS_CATEGORY_LINK = 'hac-a-dos'
export const PICOTIN_LOCK_CATEGORY_LINK = 'picotin-lock'
export const BRIDE_A_BRAC_CATEGORY_LINK = 'bride-a-brac'
export const BOLIDE_A_BRAC_CATEGORY_LINK = 'bolide'


export const CONTACT_PHONE = {
    value: '+971542205888',
    formated: '+971 54 220 5888'
}

export const CONTACT_PHONE_2 = {
    value: '+79653338881',
    formated: '+7 965 333-888-1'
}

export const RU_SITE_URL = "https://sanywatches.ru"
// export const RU_SITE_URL = "https://shops-demo.sanywatches.com/store-00000009"
export const EN_SITE_URL = "https://sanywatches.com"
// export const EN_SITE_URL = "https://shops-demo.sanywatches.com/store-00000008"



export const BENEFITES = [
    'Professional appraisers help determine fair market value',
    'Instant payouts in cash, crypto, or&nbsp;bank transfer within 24&nbsp;hours',
    'Fully insured shipping and transactions',
    'No account needed, just enter&nbsp;details and get an offer'
]

export const WORKS_STEPS = [
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M29.7735 24.594C30.8685 22.644 31.5 20.397 31.5 18C31.5 10.5435 25.4565 4.5 18 4.5C10.5435 4.5 4.5 10.5435 4.5 18C4.5 25.4565 10.5435 31.5 18 31.5C20.397 31.5 22.644 30.8685 24.594 29.7735L31.5 31.5L29.7735 24.594Z" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="17.5" cy="18.5" r="1.5" transform="rotate(-90 17.5 18.5)" fill="black" />
            <circle cx="11.5" cy="18.5" r="1.5" transform="rotate(-90 11.5 18.5)" fill="black" />
            <circle cx="23.5" cy="18.5" r="1.5" transform="rotate(-90 23.5 18.5)" fill="black" />
        </svg>,
        text: `Tell us about your Item`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M18 31.5H7.5C6.70435 31.5 5.94129 31.1839 5.37868 30.6213C4.81607 30.0587 4.5 29.2956 4.5 28.5V7.5C4.5 6.70435 4.81607 5.94129 5.37868 5.37868C5.94129 4.81607 6.70435 4.5 7.5 4.5H28.5C29.2956 4.5 30.0587 4.81607 30.6213 5.37868C31.1839 5.94129 31.5 6.70435 31.5 7.5V18" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 24H10.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.5 18H10.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.5 12H10.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M27 24V30" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M30 27H24" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Add dimensions, history
        and any documentation`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M31.5 16.5V24C31.5 28.1421 28.1421 31.5 24 31.5H12C7.85787 31.5 4.5 28.1421 4.5 24V12C4.5 7.85787 7.85787 4.5 12 4.5H19.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21.8206 14.181C23.9291 16.2902 23.9285 19.7093 21.8193 21.8178C19.7101 23.9263 16.291 23.9257 14.1826 21.8165C12.0746 19.7078 12.0746 16.2897 14.1826 14.181C16.291 12.0718 19.7101 12.0713 21.8193 14.1798C21.8197 14.1802 21.8201 14.1806 21.8206 14.181Z" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.5 6.75H33" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M29.25 10.5V3" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Upload Photos`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M4.5 18.3795C4.5 22.107 10.5435 25.1295 18 25.1295" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M31.5 18.3795C31.5 20.7195 29.1165 22.7805 25.5 23.991" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19.5 25.1295H18C10.5435 25.1295 4.5 22.107 4.5 18.3795" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.1328 28.497L19.5018 25.1295L16.1328 21.7605" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M31.5 18.3795C31.5 15.4425 27.7395 12.9525 22.5 12.0255" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="18" cy="11.6249" r="1.5" fill="black" />
            <circle cx="18" cy="6.49994" r="1.5" fill="black" />
            <circle cx="18" cy="16.4999" r="1.5" fill="black" />
            <path d="M13.5 12.024C8.2605 12.951 4.5 15.441 4.5 18.378" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Take front and back
        images of your item`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M25.5 13.5L19.1952 16.2498C18.8169 16.4148 18.4086 16.5 17.9959 16.5C17.5832 16.5 17.1749 16.4148 16.7966 16.2498L10.5 13.5036" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 28.5H25.5C27.0913 28.5 28.6174 27.8679 29.7426 26.7426C30.8679 25.6174 31.5 24.0913 31.5 22.5V12C31.5 10.4087 30.8679 8.88258 29.7426 7.75736C28.6174 6.63214 27.0913 6 25.5 6H10.5C8.9087 6 7.38258 6.63214 6.25736 7.75736C5.13214 8.88258 4.5 10.4087 4.5 12V17.25" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.5 24.7499H12" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 21.75L12 24.75L9 27.75" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Review and Submit`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M12.9727 13.6647V9.42203" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15.0942 11.5433H10.8516" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M24.0008 23.895L18.3008 18.15" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.9714 20.0147C17.65 20.0147 21.4427 16.2219 21.4427 11.5433C21.4427 6.86475 17.65 3.07199 12.9714 3.07199C8.29275 3.07199 4.5 6.86475 4.5 11.5433C4.5 16.2219 8.29275 20.0147 12.9714 20.0147Z" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19.372 6H25.5C28.8137 6 31.5 8.68629 31.5 12V25.5C31.5 28.8137 28.8137 31.5 25.5 31.5H12C8.68629 31.5 6 28.8137 6 25.5V16.3552" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `All set! Our specialists will
        review your submission`
    },
]

export const TYPES = [
    {
        title: 'Watches',
        formated: 'watches'
    },
    {
        title: 'Jewelry',
        formated: 'jewelry'
    },
    {
        title: 'Hermès Bags',
        formated: 'hermes'
    },
    // {
    //     title: 'Fine Art',
    //     formated: 'fine_art'
    // },
    {
        title: 'Other',
        formated: 'other'
    }
]

export const TELEGRAM_CONTACT_LINK = "https://t.me/sanywatch"
export const WHATSAPP_CONTACT_LINK = "https://wa.me/971564371818"

export const QUESTIONS = [
    {
        _id: getRandomId(),
        question: "Who is Sany Watches?",
        answer: "Sany Watches is&nbsp;a&nbsp;luxury watch dealer located in&nbsp;Dubai &amp;&nbsp;Moscow, founded by&nbsp;a&nbsp;passionate entrepreneur with a&nbsp;family legacy in&nbsp;watches &amp; fine jewelry. We&nbsp;specialize in&nbsp;sourcing and selling <b>premium, authentic timepieces from the world&rsquo;s most respected brands.</b>",
    },
    {
        _id: getRandomId(),
        question: "Are your watches 100% authentic?",
        answer: "<b>Absolutely.</b> We&nbsp;guarantee that every watch we&nbsp;sell is&nbsp;genuine, sourced from authorized dealers or&nbsp;trusted suppliers. Our verification process ensures each timepiece meets the highest standard of&nbsp;authenticity.",
    },
    {
        _id: getRandomId(),
        question: "What types of watches do you offer?",
        answer: "We&nbsp;offer a&nbsp;wide range of&nbsp;luxury watches, including brand-new, pre-owned, and vintage pieces. Our collection features coveted names like <b>Rolex</b>, <b>Patek&nbsp;Philippe</b>, <b>Audemars&nbsp;Piguet</b>, <b>Richard Mille</b> and more&mdash;carefully curated for both new buyers and seasoned collectors.",
    },
    {
        _id: getRandomId(),
        question: "Why are your prices lower than retail stores?",
        answer: "By&nbsp;leveraging direct partnerships with suppliers, minimizing overhead costs, and purchasing in&nbsp;volume, we&nbsp;secure exclusive deals at&nbsp;preferential rates. We&nbsp;then pass these savings on&nbsp;to&nbsp;our customers, offering genuine luxury watches at&nbsp;highly competitive prices.",
    },
    {
        _id: getRandomId(),
        question: "How can I purchase a watch from Sany Watches?",
        answer: "Simply browse our online catalog or&nbsp;contact&nbsp;us directly for personalized assistance. We&nbsp;offer secure payment options, worldwide shipping, and <b>VIP consultations</b> for rare or&nbsp;bespoke pieces&mdash;making your purchase process smooth and tailored to&nbsp;your needs.",
    },
    {
        _id: getRandomId(),
        question: "Do you offer worldwide shipping?",
        answer: "<b>Yes.</b> We&nbsp;ship globally from our locations in&nbsp;Dubai &amp;&nbsp;Moscow, using secure and insured methods to&nbsp;ensure your watch arrives safely and on&nbsp;time.",
    },
    {
        _id: getRandomId(),
        question: "Do your watches come with original box and papers?",
        answer: "Whenever possible, we&nbsp;provide the watch&rsquo;s original box, papers, and accessories. For pre-owned models, availability may vary; we&nbsp;always disclose whether full sets are included.",
    },
    {
        _id: getRandomId(),
        question: "Do you offer warranty on your watches?",
        answer: "<b>Yes.</b> New watches typically come with a&nbsp;manufacturer&rsquo;s warranty, while pre-owned pieces may include a&nbsp;store warranty. We&nbsp;thoroughly inspect and service each watch to&nbsp;ensure it&nbsp;meets our quality standards.",
    },
    {
        _id: getRandomId(),
        question: "How do you verify the authenticity of pre-owned watches?",
        answer: "We&nbsp;have a&nbsp;rigorous authentication process involving expert appraisers, thorough inspections, and cross-checks with manufacturer records. This ensures each pre-owned watch is&nbsp;genuine before it&rsquo;s added to&nbsp;our collection.",
    },
    {
        _id: getRandomId(),
        question: "What payment methods do you accept?",
        answer: "We&nbsp;accept major credit cards, bank transfers, and in&nbsp;some cases, digital payment methods like PayPal or&nbsp;cryptocurrency. Our team will guide you to&nbsp;the option most convenient for your location and currency.",
    },
    {
        _id: getRandomId(),
        question: "Do you offer financing or installment plans?",
        answer: "<b>Yes,</b> we&nbsp;have flexible financing options available through select partners, allowing you to&nbsp;spread out the cost of&nbsp;your watch. Specific terms and conditions depend on&nbsp;your region and credit approval.",
    },
    {
        _id: getRandomId(),
        question: "Do you buy watches from individuals?",
        answer: "We&nbsp;do&nbsp;purchase select high-quality watches from private sellers. Our team will evaluate your watch based on&nbsp;its condition, market demand, and current value to&nbsp;provide a&nbsp;fair offer.",
    },
    {
        _id: getRandomId(),
        question: "Can I trade in my watch for another model?",
        answer: "<b>Absolutely.</b> We&nbsp;offer trade-in services that allow you to&nbsp;exchange your current watch for a&nbsp;different model. After valuation, we&rsquo;ll discuss your upgrade options to&nbsp;ensure you find the perfect timepiece.",
    },
    {
        _id: getRandomId(),
        question: "How long does delivery take?",
        answer: "Delivery times vary by&nbsp;location. For in-stock items, domestic shipping usually takes 1-3 business days, while international orders typically arrive within 5-10 business days. We&nbsp;provide tracking information so&nbsp;you can follow your shipment&rsquo;s progress.",
    },
    {
        _id: getRandomId(),
        question: "Is shipping insured?",
        answer: "<b>Yes.</b> We&nbsp;fully insure every shipment to&nbsp;protect your investment against loss or&nbsp;damage in&nbsp;transit. This coverage ensures timepiece of&nbsp;mind until your watch is&nbsp;safely in&nbsp;your hands.",
    },
    {
        _id: getRandomId(),
        question: "Do you provide watch customization services?",
        answer: "We&nbsp;can assist with customizations such as&nbsp;strap changes, special engravings, and limited design modifications. For more advanced options like diamond settings, we&nbsp;collaborate with trusted specialists to&nbsp;ensure exceptional quality.",
    },
];

export const Y_MAP_API_KEY = '8f7dff30-8c1b-4f02-b103-44eeca43e8b6'

export const APPSTORE_APP_LINK = 'https://apps.apple.com/us/app/sany/id6748041729'
export const PLAYMARKET_APP_LINK = 'https://play.google.com/store/apps/details?id=com.sanywatches.app'